import { render, staticRenderFns } from "./AsignaCondecoracionPersonalDialogComponent.vue?vue&type=template&id=f9729fd6&scoped=true"
import script from "./AsignaCondecoracionPersonalDialogComponent.vue?vue&type=script&lang=js"
export * from "./AsignaCondecoracionPersonalDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./AsignaCondecoracionPersonalDialogComponent.vue?vue&type=style&index=0&id=f9729fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9729fd6",
  null
  
)

export default component.exports